var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidesTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "guides_tips_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.28,
    y: 0.67,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.28,
    y: 0.67,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.22,
    y: 0.8,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "guides_tips"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lightbulb"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 301,
    r: 300,
    fill: "#fdba61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,426.8v18.78a5.85,5.85,0,0,1-5.83,5.88H252.08a5.85,5.85,0,0,1-5.82-5.88V426.8Z",
    fill: "#d88219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.83,500.77v6.45a5.85,5.85,0,0,1-5.83,5.87H274.08a5.85,5.85,0,0,1-5.82-5.87v-6.45Z",
    fill: "#d88219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,463.21v1.15a11.7,11.7,0,0,1-11.65,11.75H257.91a11.7,11.7,0,0,1-11.65-11.75v-1.15a11.79,11.79,0,0,1,4.54-9.31,11.54,11.54,0,0,1,7.11-2.44h84.27A11.7,11.7,0,0,1,353.83,463.21Z",
    fill: "#d88219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,487.86V489a11.71,11.71,0,0,1-11.66,11.76H262.8a11.43,11.43,0,0,1-6.25-1.84,11.78,11.78,0,0,1-5.4-9.92v-1.15a11.73,11.73,0,0,1,6.93-10.74,11.36,11.36,0,0,1,4.72-1h74.49A11.71,11.71,0,0,1,349,487.86Z",
    fill: "#d88219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.78,288.74c4.89-39.88-15.91-79.59-44.37-103.53-34.16-28.75-73.38-29.8-85.74-29.6-12.69-.18-51.57,1.07-85.46,29.6-28.46,23.95-49.27,63.65-44.38,103.54,3,24.71,15.22,43.73,17.26,46.84C201.11,357,215,361.12,229,382.43a112.83,112.83,0,0,1,16.81,44.38h108c0-.16.05-.3.07-.45a112.6,112.6,0,0,1,16.75-43.93c14-21.31,27.88-25.43,41.9-46.84C414.56,332.48,426.75,313.46,429.78,288.74Z",
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.42,
    y: 273.96,
    width: 84.76,
    height: 31.78,
    rx: 15.89,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.81,
    y: 273.96,
    width: 84.76,
    height: 31.78,
    rx: 15.89,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.76,
    y: 134.6,
    width: 63.57,
    height: 31.78,
    rx: 15.89,
    transform: "translate(21.15 352.05) rotate(-45)",
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.18,
    y: 118.71,
    width: 31.78,
    height: 63.57,
    rx: 15.89,
    transform: "translate(-59.53 157.27) rotate(-45)",
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.42,
    y: 43,
    width: 31.78,
    height: 84.76,
    rx: 15.89,
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.6,
    y: 407.64,
    width: 63.57,
    height: 31.78,
    rx: 15.89,
    transform: "translate(-252.5 237.46) rotate(-45)",
    fill: "#fffbc5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.18,
    y: 395.02,
    width: 31.78,
    height: 63.57,
    rx: 15.89,
    transform: "translate(-174.37 432.65) rotate(-45)",
    fill: "#fffbc5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidesTips);
export default __webpack_public_path__ + "static/media/guides_tips.bee06146927daa7a978b062580af9b5c.svg";
export { ForwardRef as ReactComponent };